import { SessionState } from '@uplift/types';
import { restClient } from '../../client';


type ChangeAppointmentStateResponse = {
  status: string;
  error: '';
} | {
  status: '';
  error: string;
};

export const changeAppointmentState = (appointmentId: string, state: SessionState) =>
  restClient.request<ChangeAppointmentStateResponse>('/appointment/state/update', {
    method: 'POST',
    data: {
      appointment_id: appointmentId,
      state: state,
    }
  });
